const wrapClasses =
    'rounded-xl border border-primary/30 bg-primary/5 px-5 py-4 mb-4 text-center';

const labelClasses = 'text-xs font-semibold uppercase tracking-wider text-subtle m-0';

const valueClasses = 'text-3xl font-bold text-primary mt-1 mb-0';

const rangeClasses = 'text-sm text-subtle mt-1 mb-0';

const LifecarePlanTotalValue = ({ totalValueFormatted, totalValueLowFormatted, totalValueHighFormatted }) => (
    <div className={wrapClasses}>
        <p className={labelClasses}>Total life care plan value</p>
        <p className={valueClasses}>{totalValueFormatted}</p>
        <p className={rangeClasses}>
            Estimated range {totalValueLowFormatted} - {totalValueHighFormatted}
        </p>
    </div>
);

export default LifecarePlanTotalValue;
